import { useState } from 'react';

export default function HeroSection() {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Clean%20minimal%20modern%20workspace%20with%20laptop%20displaying%20organized%20product%20spreadsheet%20data%20on%20screen%2C%20warm%20soft%20natural%20lighting%20from%20large%20windows%2C%20cream%20walls%2C%20small%20ceramic%20vase%20with%20dried%20lavender%2C%20stylish%20notebook%20and%20coffee%20cup%2C%20editorial%20photography%20with%20warm%20earthy%20tones%2C%20calm%20productive%20atmosphere%2C%20organic%20textures%2C%20high%20end%20lifestyle%20aesthetic&width=1600&height=900&seq=hero-bg-v2&orientation=landscape"
          alt="Modern workspace with spreadsheet"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-black/10 to-background-50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-[640px]">
          {/* Trust Badges */}
          <div className="flex flex-wrap items-center gap-2 md:gap-3 mb-6">
            {['Updated Resources', 'Organized Categories', 'Beginner Friendly', 'Safety Verified'].map((badge) => (
              <span
                key={badge}
                className="px-3 py-1.5 text-xs font-medium bg-background-50/90 text-primary-700 rounded-full whitespace-nowrap backdrop-blur-sm"
              >
                <i className="ri-check-line mr-1 text-primary-500"></i>
                {badge}
              </span>
            ))}
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-[56px] font-heading font-bold text-background-50 leading-tight mb-4">
            Vigorbuy Spreadsheet — Your Complete Resource For Smarter Shopping
          </h1>

          <p className="text-base md:text-lg text-background-100/90 leading-relaxed mb-8 max-w-lg">
            Find organized Vigorbuy Spreadsheet collections, product guides and expert recommendations designed to help you discover products faster and shop with confidence.
          </p>

          {/* Search Bar */}
          <div className="flex flex-col sm:flex-row gap-3 mb-6">
            <div className="relative flex-1">
              <div className="w-9 h-9 flex items-center justify-center absolute left-3 top-1/2 -translate-y-1/2">
                <i className="ri-search-line text-base text-foreground-400"></i>
              </div>
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search Vigorbuy Spreadsheet Guides..."
                className="w-full pl-10 pr-4 py-3 text-sm bg-background-50 text-foreground-800 rounded-full border border-background-200 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-transparent placeholder:text-foreground-400"
              />
            </div>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-6 py-3 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-colors text-center whitespace-nowrap cursor-pointer"
            >
              Explore Vigorbuy Spreadsheet
            </a>
          </div>

          {/* Secondary CTA */}
          <div className="flex items-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-sm font-medium text-background-100 hover:text-background-50 underline underline-offset-4 decoration-background-100/40 hover:decoration-background-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              View Complete Buying Guides →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}